import {IController, IFormController, IModule, INgModelController, IScope, ITimeoutService} from "angular";
import {Debugger} from "debug";
import _ from "lodash";
import {scrollTilSenter} from "../../../felles/stoettefunk/scroll";
import {regNavn} from "../../../felles/tjenester/tredjepartsTjenestenavn";
import {FeltEndretEventTriggerDirektiv} from "../../../felles/direktiver/feltEndretEventTrigger"; //uten denne kompilerer ikke uttrykket moment.tz

const debuger = require('debug');
const debug: Debugger = debuger('FeltfeilINestedeSkjemaKontroller');

require('./feltfeilINestedeSkjema.scss');

export class FeltfeilINestedeSkjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkFeltfeilINestedeSkjema', {
                bindings: {skjema: '<', scope: '<', feilmeldingerpoperty: '=', noekkelOmskrivning: '&?'},
                controller: FeltfeilINestedeSkjemaKontroller.forInjisering(),
                template: require('./feltfeilINestedeSkjema.html'),
                transclude: true
            });
    }

    static forInjisering() {
        return [regNavn.ng.$timeout, FeltfeilINestedeSkjemaKontroller]
    }

    skjema: IFormController; //settes via bindings/$onChanges
    scope: IScope; //settes via bindings/$onChanges
    feilmeldingerpoperty: FeltfeilINestedeSkjema; //eksporteres via bindings - toveisbundet slik at endringer utført i komp her er synlig i forelder
    noekkelOmskrivning: (args: { noekkel: string }) => string; //settes via bindings

    constructor(private $timeout: ITimeoutService) {
    }

    $onInit(): void {
        this.scope.$on(FeltEndretEventTriggerDirektiv.eventer.feltendret, () => this.beregnFeltfeil());
        this.$timeout(() => this.beregnFeltfeil(), 2000);
    }

    private beregnFeltfeil() {
        const feltfeil = new FeltfeilINestedeSkjemaBeregning(this.skjema).feilPerFeltnavnSomMap(nøkkel => this.nøkkelOmskrivningKall(nøkkel));
        debug('beregnFeltfeil', feltfeil)
        this.feilmeldingerpoperty = new FeltfeilINestedeSkjema(feltfeil, this.$timeout);
    }

    private nøkkelOmskrivningKall(nøkkel: string) {
        if (!this.noekkelOmskrivning) return nøkkel;
        return this.noekkelOmskrivning({noekkel: nøkkel});
    }
}


class FeltfeilINestedeSkjemaBeregning {

    private feltfeil: Feltfeil[] = [];

    private skjemasti: string[] = [];

    constructor(private skjema: IFormController) {
        for (let feiltype in skjema.$error) {
            this.ekstraherFraSkjema(skjema, feiltype);
        }
    }

    public feilPerFeltnavn(): FeltfeilOgAntall[] {
        return Object.entries(_.groupBy(this.feltfeil, felt => felt.nøkkel))
            .map(([nøkkel, feil]) => ({feil: feil[0], antall: feil.length}));
    }

    public feilPerFeltnavnSomMap(nøkkelOmskrivning: (nøkkel: string) => string = nøkkel => nøkkel): _.Dictionary<Feltfeil[]> {
        return _.groupBy(this.feltfeil, felt => nøkkelOmskrivning(felt.nøkkel))
    }

    private ekstraherFraSkjema(skjema: IFormController, feiltype: string) {
        this.skjemasti.push(skjema.$name);
        this.ekstraher(skjema.$error[feiltype], feiltype);
        this.skjemasti.pop();
    }

    private ekstraher(skjemkontrollereMedFeil: Array<INgModelController | IFormController>, feiltype: string) {
        skjemkontrollereMedFeil.forEach((skjemakontroller => {
            if (this.erFelt(skjemakontroller)) {
                const feltKontroller: INgModelController = <INgModelController>skjemakontroller;
                feltKontroller.$setTouched(); //for å tvinge at feltet blir markert visuelt som feilet
                this.feltfeil.push(new Feltfeil(feltKontroller, feiltype, this.skjemasti));
                //debug("felt med feil", feltKontroller.$invalid, feltKontroller.$name, feltKontroller);

            } else {
                const skjemaKontroller: IFormController = <IFormController>skjemakontroller;
                //debug("rekurserer inn i skjema", skjemaKontroller.$invalid, skjemaKontroller.$name, skjemaKontroller.$error.required)
                this.ekstraherFraSkjema(skjemaKontroller, feiltype);
            }
        }))
    }

    private erFelt(kandidat: INgModelController | IFormController) {
        return _.has(kandidat, '$touched');
    }
}

export class Feltfeil {

    feltnavn: string;
    feiltype: string;
    nøkkel: string;

    constructor(private feltFeil: INgModelController, feiltype: string, skjemasti: string[]) {
        this.feltnavn = feltFeil.$name;
        this.feiltype = feiltype;
        this.nøkkel = `${skjemasti.join('.')}.${feltFeil.$name}.${this.feiltype}`;
    }

    element() {
        return (<JQuery>(<any>this.feltFeil).$$element).first();
    }
}

interface FeltfeilOgAntall {
    feil: Feltfeil;
    antall: number;
}

export class FeltfeilINestedeSkjema {

    constructor(public feil: _.Dictionary<Feltfeil[]>, private $timeout: ITimeoutService) {
    }

    fokuserFoersteFeilIKategori(nøkkel: string) {
        if (!this.feil[nøkkel]) return;
        const element = this.feil[nøkkel][0].element();
        scrollTilSenter(element);
        this.$timeout(() => element.focus(), 1000); //.focus() avbryter animert scrollTilSenter() - venter derfor 1 sek
    }

    antallAvKategori(nøkkel: string): number {
        if (!this.feil[nøkkel]) return 0;
        return this.feil[nøkkel].length;
    }
}